import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { StepService } from 'src/app/services/step.service';

@Component({
  selector: 'app-helpstep',
  templateUrl: './helpstep.component.html',
  styleUrls: ['./helpstep.component.scss'],
})
export class HelpstepComponent implements OnInit {
  @Input() step: number;
  currentStep: number;
  steptitle: string;
  stepintro: string;
  stepnumber: string;

  constructor(
    private translateService: TranslateService,
    private stepService: StepService
  ) {}

  ngOnInit() {
    if (this.step) {
      if (this.step < 10) {
        this.stepnumber = '0' + this.step.toString();
      } else {
        this.stepnumber = this.step.toString();
      }

      this.steptitle = this.translateService.instant(this.stepService.stepName(this.step) + '.TITLE');
      this.stepintro = this.translateService.instant(this.stepService.stepName(this.step) + '.INTRODUCTIONTEXT');

      this.currentStep = this.stepService.getActiveStep();

      this.stepService.stepChange$.subscribe(newStep => {
        this.currentStep = newStep;
      });
    }
  }
}
